document.addEventListener('DOMContentLoaded', () => {
  const mobileImageSwapQuery = window.matchMedia('(max-width: 899px) and (hover: none), (max-width: 899px) and (pointer: coarse)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const imageSwapCards = [...document.querySelectorAll('.coffee-card, .typo-rd__product')].filter((card) => (
    card.querySelector('.coffee-card__image-layer--secondary, .typo-rd__product-image--secondary')
  ));
  let imageSwapFrame = null;

  const clearMobileImageSwaps = () => {
    imageSwapCards.forEach((card) => card.classList.remove('is-mobile-revealed'));
  };

  const updateMobileImageSwap = () => {
    imageSwapFrame = null;

    if (!mobileImageSwapQuery.matches || reducedMotionQuery.matches) {
      clearMobileImageSwaps();
      return;
    }

    const viewportCenter = window.innerHeight / 2;
    const activationDistance = Math.min(180, window.innerHeight * 0.22);
    let closestCard = null;
    let closestDistance = Number.POSITIVE_INFINITY;

    imageSwapCards.forEach((card) => {
      const media = card.querySelector('.coffee-card__image, .typo-rd__product-media');
      if (!media) return;

      const rect = media.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

      const distance = Math.abs((rect.top + rect.bottom) / 2 - viewportCenter);
      if (distance < closestDistance) {
        closestCard = card;
        closestDistance = distance;
      }
    });

    imageSwapCards.forEach((card) => {
      card.classList.toggle('is-mobile-revealed', card === closestCard && closestDistance <= activationDistance);
    });
  };

  const scheduleMobileImageSwap = () => {
    if (imageSwapFrame !== null) return;
    imageSwapFrame = window.requestAnimationFrame(updateMobileImageSwap);
  };

  if (imageSwapCards.length) {
    window.addEventListener('scroll', scheduleMobileImageSwap, { passive: true });
    window.addEventListener('resize', scheduleMobileImageSwap, { passive: true });
    mobileImageSwapQuery.addEventListener('change', scheduleMobileImageSwap);
    reducedMotionQuery.addEventListener('change', scheduleMobileImageSwap);
    scheduleMobileImageSwap();
  }

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-product-gallery-main]');
    if (!main) return;

    gallery.querySelectorAll('[data-gallery-image]').forEach((button) => {
      button.addEventListener('click', () => {
        main.src = button.dataset.galleryImage;
        main.removeAttribute('srcset');
        gallery.querySelectorAll('[data-gallery-image]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('[data-product-page]').forEach((page) => {
    const price = page.querySelector('[data-product-price]');
    const variantsNode = page.querySelector('[data-product-variants]');
    const variantInput = page.querySelector('[data-product-variant-id]');
    const optionGroups = [...page.querySelectorAll('[data-product-option]')];
    if (!variantsNode || !variantInput || !optionGroups.length) return;

    const variants = JSON.parse(variantsNode.textContent);
    const normalize = (value) => String(value || '').toLowerCase().replace(/[·×]/g, ' ').replace(/[\s_-]+/g, ' ').trim();
    const formatMoney = (cents) => {
      const amount = (Number(cents) / 100).toFixed(2);
      return (page.dataset.moneyFormat || '€{{amount}}').replace(/\{\{\s*amount(?:_with_comma_separator)?\s*\}\}/, amount);
    };
    const selectedOptions = () => optionGroups.map((group) => group.querySelector('input:checked')?.value || '');

    const syncTempoContext = (selected) => {
      const tempo = normalize(selected[0]);
      page.querySelectorAll('[data-tempo-context]').forEach((context) => {
        const active = normalize(context.dataset.tempoContext) === tempo;
        context.hidden = !active;
        context.querySelectorAll('input, select').forEach((control) => { control.disabled = !active; });
      });
    };

    const syncAvailability = (selected) => {
      optionGroups.forEach((group, optionIndex) => {
        group.querySelectorAll('input').forEach((input) => {
          const possible = variants.some((variant) => variant.available && (
            optionIndex === 0
              ? variant.options[optionIndex] === input.value
              : variant.options.every((value, index) => (
                  index === optionIndex ? value === input.value : value === selected[index]
                ))
          ));
          input.disabled = !possible;
        });
      });
    };

    const setVariant = (changedIndex = null) => {
      let selected = selectedOptions();
      let variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));

      if (!variant && changedIndex !== null) {
        variant = variants.find((item) => item.available && item.options[changedIndex] === selected[changedIndex]);
        if (variant) {
          optionGroups.forEach((group, index) => {
            const input = [...group.querySelectorAll('input')].find((item) => item.value === variant.options[index]);
            if (input) input.checked = true;
          });
          selected = selectedOptions();
        }
      }

      if (!variant) variant = variants.find((item) => item.available);
      if (!variant) return;

      variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.displayPrice);
      syncTempoContext(selected);
      syncAvailability(selected);

      const submit = page.querySelector('.product-form__actions button[type="submit"]');
      if (submit) {
        submit.disabled = !variant.available;
        submit.innerHTML = variant.available ? 'Add to bag <span aria-hidden="true">&rarr;</span>' : 'Sold out';
      }
    };

    const params = new URLSearchParams(window.location.search);
    const requested = {
      tempo: normalize(params.get('track')),
      size: normalize(params.get('size')),
    };

    optionGroups.forEach((group, index) => {
      const requestedValue = requested[group.dataset.productOptionName];
      if (requestedValue) {
        const match = [...group.querySelectorAll('input')].find((input) => normalize(input.value).includes(requestedValue));
        if (match) match.checked = true;
      }
      group.querySelectorAll('input').forEach((input) => input.addEventListener('change', () => setVariant(index)));
    });

    setVariant(0);
  });
});
